<template>
  <div class="flex flex-col items-center justify-center gap-y-2">
    <div class="relative flex h-40 flex-col overflow-hidden rounded-md">
      <img
        class="h-full w-full object-cover"
        :src="
          image.url.includes('data') || image.url.includes('/uploads/')
            ? image.url
            : `/uploads/${image.url}`
        "
        :alt="__('Media image')"
      />

      <button
        class="absolute inset-0 flex items-center justify-center bg-zinc-800/75 opacity-0 transition-opacity hover:opacity-100 focus:opacity-100"
        type="button"
        :aria-label="__('Delete')"
        @click="handleDeleteButtonClick"
      >
        <Icon class="text-xl text-white" name="delete" />
      </button>
    </div>

    <input
      v-if="has_primary_photo_logic !== false"
      type="checkbox"
      class="size-5 rounded-xl border-gray-300 text-primary focus:shadow-none focus:outline-none focus:ring-0 focus:ring-offset-0"
      :checked="is_primary === true"
      @change="$emit('checked')"
    />
  </div>
</template>

<script setup>
  import { Icon } from '@/components/block/icon';

  defineProps({
    image: {
      type: Object,
      required: true
    },
    has_primary_photo_logic: {
      type: Boolean,
      required: false,
      default: false
    },
    is_primary: {
      type: Boolean,
      required: false,
      default: null
    }
  });

  const emits = defineEmits(['delete']);

  function handleDeleteButtonClick() {
    emits('delete');
  }
</script>
